import { motion } from "framer-motion";
import { scrollToId } from "../lib/scroll";

export default function Filosofia() {
  return (
    <section
      id="filosofia"
      className="relative bg-background py-28 md:py-40 border-t border-white/10"
      data-testid="filosofia-section"
    >
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="flex items-center justify-center gap-4 mb-8">
            <span className="h-px w-10 bg-primary" />
            <span className="text-[11px] tracking-[0.35em] text-primary">
              CHI C'È DIETRO IL METODO
            </span>
            <span className="h-px w-10 bg-primary" />
          </div>

          <blockquote className="font-serif font-light text-3xl md:text-5xl text-foreground leading-tight text-balance">
            “L'azione imperfetta batte sempre{" "}
            <span className="italic text-primary">la perfezione immobile.</span>”
          </blockquote>

          <p className="mt-12 max-w-2xl mx-auto text-muted-foreground leading-relaxed">
            Sono Francesco Galli, fondatore del Metodo Sintesi. Non vengo dalla
            teoria: vengo dal campo. Unisco una solida formazione tecnica in PNL
            a un approccio pragmatico e orientato al risultato concreto.
          </p>
          <p className="mt-4 max-w-2xl mx-auto text-muted-foreground leading-relaxed">
            Niente fuffa motivazionale, niente frasi da poster. Solo un metodo
            per smontare i tuoi blocchi e rimetterti in movimento — nella tua
            impresa, nello sport e nella tua vita.
          </p>

          <div className="mt-10 flex items-center justify-center gap-4">
            <span className="font-serif text-xl text-foreground">
              Francesco Galli
            </span>
            <span className="h-4 w-px bg-white/20" />
            <span className="text-xs tracking-[0.2em] text-primary">
              MENTAL COACH & PNL
            </span>
          </div>

          <button
            onClick={() => scrollToId("candidatura")}
            className="mt-12 inline-flex items-center gap-3 rounded-full border border-primary/60 px-8 py-4 text-sm tracking-[0.12em] text-primary hover:bg-primary hover:text-primary-foreground transition-colors duration-300"
            data-testid="filosofia-cta"
          >
            LAVORIAMO INSIEME →
          </button>
        </motion.div>
      </div>
    </section>
  );
}
